export const pagerText = {
  previous: {
    en: 'Previous',
    nb: 'Forrige',
    nn: 'Forrige',
  },
  next: {
    en: 'Next',
    nb: 'Neste',
    nn: 'Neste',
  },
} as const;